module.exports = __webpack_public_path__ + "img/no-money.0e457fc8.png";